import React, {FC} from 'react'
import { withRouter } from 'react-router-dom'
import flowRight from 'lodash/flowRight'
import { useMount } from 'react-nb-hooks'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKModal, { LKModalContainer } from 'shared/LKModal'

import { type } from './constants'
import container from './container'
import translate from './translate'

import AddForm from './Form'

import { OfficerAddProps } from '../LoanDetails/types.LoanDetails'

const LoanOfficerAssistantAddModal: FC<OfficerAddProps> = ({
  modalInstanceName,
  ID,
  hash,
  base,
  handleModalOpen,
  close,
  loading,
  submit,
  submitting,
  manager,
}) => {
  useMount(() => {
    handleModalOpen()
    return close
  })

  return (
    <LKModal
      name={modalInstanceName}
      heading={translate('frm_loan_manager_add')}
      loading={loading}
      size="sm-1"
      footer={
        <LKModal.Footer
          sideActions={
            <LKButton alias="add" disabled={submitting || !manager} onClick={submit} loading={submitting}>
              {translate('cmd_finish')}
            </LKButton>
          }
        />
      }
    >
      {/* @ts-ignore */}
      <AddForm name={modalInstanceName} ID={ID} hash={hash} base={base} />
    </LKModal>
  )
}

LoanOfficerAssistantAddModal.defaultProps = {
  error: {},
  loading: true,
}

const enhance = flowRight(withRouter, container, React.memo)

export const LoanOfficerAdd = enhance(LKModalContainer(type.officer)(LoanOfficerAssistantAddModal))

export const LoanOfficerAssistantAdd = enhance(LKModalContainer(type.assistant)(LoanOfficerAssistantAddModal))
